var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{ 'is-mobile': _vm.isMobile },attrs:{"id":"app"}},[(!_vm.isMobile)?[(
        _vm.$route.name !== '/agreement/index' &&
          _vm.$route.name !== '/agreement/contact'
      )?[_c('TopBar'),(_vm.rightSuspensionFlag)?_c('RightSuspension'):_vm._e(),_c('router-view'),_c('declare'),_c('Footer')]:_c('router-view')]:_c('div',{staticClass:"app-guide"},[_c('img',{staticClass:"app-guide__img",attrs:{"alt":"水羊直供","src":_vm.appGuidePoster}}),_c('div',{staticClass:"app-guide__btn",on:{"click":_vm.getUrlScheme}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }